import type { AuctionCar } from '@autobid/ui/types/Car'

export function getFirstRegistration(eq: AuctionCar['equipments']) {
  return eq.eq21
}
